<template>
  <div>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent width="350">
        <v-card>
          <v-card-title class="headline">Learning Item Delete</v-card-title>
          <v-card-text
            >If you delete this Learning Item <strong>{{ item.name }}</strong
            >, it will be gone for good. Delete only if you are
            sure.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              id="js-delete-confirm"
              class="dangerous-action-btn"
              @click="deleteItem()"
              >Delete</v-btn
            >
            <v-btn class="cancel-action-btn" @click="dialog = false"
              >Cancel</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-card class="item_details" outlined>
      <v-card-text>
        <p class="display-1 text--primary">
          {{ item.name }}
        </p>
        <p>{{ item.description }}</p>
        <div class="text--primary">
          <v-simple-table dense class="details-table">
            <tbody>
              <tr>
                <th class="text-left">templates</th>
                <td v-if="numberOfTemplates > 0" id="js-number-of-templates">
                  {{ numberOfTemplates }}
                </td>
                <td v-if="numberOfTemplates > 0" id="js-names-of-templates">
                  {{ templateNames.join(", ") }}
                </td>
                <td v-if="numberOfTemplates == 0">
                  <v-skeleton-loader type="list-item"></v-skeleton-loader>
                </td>
                <td v-if="numberOfTemplates == 0">
                  <v-skeleton-loader type="list-item"></v-skeleton-loader>
                </td>
              </tr>
              <tr>
                <th class="text-left">assigned</th>
                <td v-if="numberOfTemplates > 0" id="js-number-assigned">
                  {{ numberAssigned }}
                </td>
                <td v-if="numberOfTemplates > 0" id="js-names-assigned">
                  {{ assignedToUsers.join(", ") }}
                </td>
                <td v-if="numberOfTemplates == 0">
                  <v-skeleton-loader type="list-item"></v-skeleton-loader>
                </td>
                <td v-if="numberOfTemplates == 0">
                  <v-skeleton-loader type="list-item"></v-skeleton-loader>
                </td>
              </tr>
              <tr>
                <th class="text-left">completed</th>
                <td v-if="numberOfTemplates > 0" id="js-number-completed">
                  {{ numberCompleted }}
                </td>
                <td v-if="numberOfTemplates > 0" id="js-names-completed">
                  {{ completedUsers.join(", ") }}
                </td>
                <td v-if="numberOfTemplates == 0">
                  <v-skeleton-loader type="list-item"></v-skeleton-loader>
                </td>
                <td v-if="numberOfTemplates == 0">
                  <v-skeleton-loader type="list-item"></v-skeleton-loader>
                </td>
              </tr>
              <tr>
                <th class="text-left">responses</th>
                <td id="js-number-of-responses">{{ numberOfResponses }}</td>
                <td></td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <v-btn
          id="js-item-delete-button"
          v-if="showDelete"
          small
          class="dangerous-action-btn item-delete-button"
          @click="confirmDeleteItem"
          >Delete</v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    item: { type: Object, default: () => {} }
  },
  data: function() {
    return {
      deleteItemId: 0,
      dialog: false
    }
  },
  created() {
    this.$store.dispatch("courses/loadCourses", {
      showTemplates: true,
      includeHidden: true
    })
  },
  computed: {
    numberOfTemplates() {
      return this.templates.length
    },
    showDelete() {
      let b = this.numberAssigned + this.numberOfTemplates == 0
      // console.log("show delete: " + b)
      return b
    },
    templates() {
      let courses = this.$store.getters["courses/getTemplates"]

      let parentCourses = courses.filter(el => {
        let containsThisItem = el.learning_items.filter(el => {
          return el.id == this.item.id
        })

        return containsThisItem.length > 0
      })

      return parentCourses ? parentCourses : []
    },
    templateNames() {
      let names = this.templates.map(el => el.name)

      return names
    },
    numberOfResponses() {
      return this.item.responses.length
    },
    assigned() {
      let items = this.$store.getters[
        "learningItems/getLearningItemsByParentId"
      ](this.item.id)
      return items ? items : []
    },
    numberAssigned() {
      return this.assigned.length
    },
    assignedToUsers() {
      let items = this.assigned

      let users = this.getNames(items)

      return users
    },
    numberCompleted() {
      let assignedItems = this.assigned
      let completedAssignedItems = assignedItems.filter(el => el.status == true)

      return completedAssignedItems.length
    },
    completedUsers() {
      let assignedItems = this.assigned
      let completedAssignedItems = assignedItems.filter(el => el.status == true)

      let users = this.getNames(completedAssignedItems)

      return users
    }
  },
  methods: {
    getNames(items) {
      let users = items.map(el => {
        let user = this.$store.getters["users/getUser"](el.user_id)
        let name = "Other Family"
        if (user) {
          name = user.first_name
        } else {
          this.$store.dispatch("users/loadUser", parseInt(el.user_id))
        }

        return name
      })

      const map = users.reduce(
        (acc, e) => acc.set(e, (acc.get(e) || 0) + 1),
        new Map()
      )

      let compiledUsers = []
      let entries = [...map.entries()]
      for (var i = 0; i < entries.length; i++) {
        if (entries[i][1] > 1) {
          compiledUsers.push(entries[i][0] + " (x" + entries[i][1] + ")")
        } else {
          compiledUsers.push(entries[i][0])
        }
      }

      return compiledUsers
    },
    confirmDeleteItem() {
      this.deleteItemId = this.item.id
      this.dialog = true
    },
    deleteItem() {
      this.dialog = false

      this.$store.dispatch(
        "learningItems/deleteLearningItem",
        this.deleteItemId
      )

      this.$router.push({
        name: "coursesGridManager"
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/buttons";

.item_details {
  margin-bottom: 20px;
}
.details-table {
  max-width: 650px;
}
tbody {
  color: $dark-grey;
}
th {
  width: 30%;
  border-bottom: 1px solid $beige;
  text-transform: uppercase;
  font-style: italic;
}

td {
  border-bottom: 1px solid $beige !important;
}

tr:hover {
  background: $beige !important;
}

.item-delete-button {
  margin: 10px 40px 5px 40px;
}
</style>
